var rZasielkovna = {
    apiKey: null,
    openModal: function() {
        var _self = this;

        Packeta.Widget.pick(
            this.apiKey,
            function(data) {
                _self.processSelectedBranch(data);
            },
            {
                // ISO 639-1 code
                'language': Eshop.options.locale ? Eshop.options.locale.split('_')[0] : 'sk'
            }
        );
    },
    processSelectedBranch: function(data) {
        $('.js-zasielkovna-collapse').collapse('show');

        if (!data) {
            return;
        }

        var _self = this;

        $('.js-zasielkovna-holder').addClass('is-loading');
        $('.js-zasielkovna-empty').removeClass('hidden');
        $('.js-zasielkovna-selected').addClass('hidden');

        $.post('/create-zasielkovna-branch', data, function (response) {
            if (!response.status) {
                _self.failedCallback();

                return false;
            }

            data.id = response.data.id;

            _self.successCallback(data);
        }, 'json')
            .fail(function() {
                _self.failedCallback();
            });
    },
    failedCallback: function() {
        $('input[name="shipping_module_id"]').val('');
        $('.js-zasielkovna-holder').removeClass('is-loading');
    },
    successCallback: function(data) {
        $('input[name="shipping_module_id"]').val(data.id);
        $('input[name="shipping_name"]').val(data.name);
        $('input[name="shipping_address"]').val(data.street);
        $('input[name="shipping_post_code"]').val(data.zip);
        $('input[name="shipping_city"]').val(data.city);

        $('.js-zasielkovna-selected').removeClass('hidden');
        $('.js-zasielkovna-selected').find('.is-branch').text(data.place);
        $('.js-zasielkovna-selected').find('.is-address').text(data.name);
        $('.js-zasielkovna-empty').addClass('hidden');
        $('#error-zasielkovna').hide();
        $('.js-zasielkovna-holder').removeClass('is-loading');
    },
    init: function(apiKey) {
        if (!apiKey) {
            console.error('apiKey is not defined');

            return;
        }

        this.apiKey = apiKey;

        var _self = this;

        setTimeout(function() {
            $('input[name="shipping_id"]').on('change', function() {
                if ($(this).parents('.js-shopping-modules-item').data('zasielkovna')) {
                    if (!$('.js-zasielkovna-empty').hasClass('hidden')) {
                        _self.openModal();
                    }
                }
            });
        }, 100);

        $('.js-zasielkovna-trigger').on('click', function() {
            _self.openModal();
        });
    }
}

$(function() {
    rZasielkovna.init('fbd94df65d35326e');
});